(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-mobile-menu"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-save"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-recently-viewed"] && !Shopify.designMode) return;
  try {
    

window.addEventListener('DOMContentLoaded',() => {
  new ProductRecentlyViewed();
});

document.addEventListener('shopify:section:load', () => {
	new ProductRecentlyViewed();
});

class ProductRecentlyViewed {

  #recentlyViewed = [];
  #maxProducts = 10;
  #expireDuration = 90 * 1000 * 60;
  #itemContainer;
  #flickity;

  constructor()
  {
    //only if session storage is supported by the browser	
    if (typeof(localStorage) != 'undefined') this.init();
  };
  
  init()
  {
    //check expiration
  	const re = localStorage.getItem('lm_recent_viewed_lastset');
	const now = new Date().getTime();

    this.checkLegacy();
    
    //delete(localStorage.lm_recently_viewed);
    //delete(localStorage.lm_recent_viewed_lastset);
    
	//expire the data if it's over with
	if (re && (parseInt(re) + this.#expireDuration) < now) 
	{
      this.cleanup();
	}
			  	
    const rv = localStorage.getItem('lm_recently_viewed');
    if (rv) this.#recentlyViewed = JSON.parse(rv);

    //if our snipped is on the current page, then load the items
    this.#itemContainer = document.querySelector('.lm-recently-viewed-items');
    
    if (this.#itemContainer) 
    {
      this.addFromHandle();
    }
    else
    {
      //try again after a scroll if it didn't work      
      window.addEventListener('scroll', () => this.init(), {once:true});
    }
  };

  cleanup()
  {
    delete(localStorage.lm_recently_viewed);
    delete(localStorage.lm_recent_viewed_lastset);
  };

  /**
    * resets if using the old method
    */
  checkLegacy()
  {
    const rv = localStorage.getItem('lm_recently_viewed');
    if (rv) 
    {
      const data = JSON.parse(rv);
      if (data && data.length > 0 && typeof(data[0]) == 'string')
      {
        this.cleanup();
      }
    }
 
  };

  
  flickity()
  {
    if (!this.#flickity)
    {
      this.#flickity = new Flickity( '.lm-recently-viewed-items', {
  		contain: true,
  		wrapAround: false,
  		groupCells:true,
        imagesLoaded: true,
        pageDots: false
      });	  
    }

    return this.#flickity;
  }

  addFromHandle()
  {
      const handle = this.getHandle();

      if (!handle)
      {
        if (this.#recentlyViewed.length > 0) this.loadViewer();
        return;
      }

      const uri = '/products/' + handle + '.js';

	  //get the product data as json
	  fetch(uri)
    	.then(response => response.json() )
        .then(data => { 

          //we had a valid entry, store it
          this.addItem(data);
          
        }).catch(e => { 

          //silence the errors
          //console.error(e); 

        }).finally( data=> {

          //now try to load our items
          if (this.#recentlyViewed.length > 0) this.loadViewer();

        });
  };
  
  getHandle()
  {
    const matches = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);

    //nothing to do if on a product page
	return (!matches || matches.length < 2) ? false : matches[1];
  }

  getItemIndex(handle)
  {
    let itemIdx = -1;
    this.#recentlyViewed.some( (item,idx) => {
      if (item.handle == handle)
      {
        itemIdx = idx;
        return true;
      }
    });

    return itemIdx;
  }

  itemToStorage(item)
  {
    const obj = {
      handle: item.handle,
      title: item.title,
      price: item.price,
      price_varies: item.price_varies,
      url: item.url,
      imageUrl: item.featured_image.replace('.jpg','_360x.jpg'),
      hoverImageUrl: item.images.length > 1 ? item.images[1] : null
    };

    //console.log('Item To Storage',item,obj);
    return obj;
  };

  
  addItem(item)
  { 
    const itemIdx = this.getItemIndex(item.handle);
    const itemObj = this.itemToStorage(item);
    
    //not included yet - add at the beginning and trim the array
    if (itemIdx === -1)
    {
      this.#recentlyViewed.unshift(itemObj);
      this.#recentlyViewed = this.#recentlyViewed.splice(0,this.#maxProducts);
    }
    //already in the list, move it to the start of the array
    else
    {
      this.#recentlyViewed.splice(itemIdx, 1);
      this.#recentlyViewed.unshift(itemObj);
    }
    
    //set the item and the expiration
    localStorage.setItem('lm_recently_viewed',JSON.stringify(this.#recentlyViewed));
    localStorage.setItem('lm_recent_viewed_lastset',new Date().getTime());
  };

  loadViewer()
  {
    //show the wrapper
    this.#itemContainer.parentNode.style.display = 'block';    
    this.#recentlyViewed.forEach( item => {
      this.#itemContainer.append( this.addSlide(item) );
    });
    
    setTimeout( () => this.flickity(), 250);
  };

  addSlide(item)
  {
    const slide = Object.assign( document.createElement('li'), {
      className:'lm-recently-viewed-item',
    });
 
    slide.setAttribute('data-handle',item.handle); 

    //slide image
    const imgWrap = Object.assign(document.createElement('div'), { 
      className:"item-image-wrapper"
    });
    
    const imgLink = Object.assign(document.createElement('a'), {
      href: item.url,
      className: 'full-unstyled-link'
    });

    const img = Object.assign( document.createElement('img'), { src: item.imageUrl });

  	imgLink.appendChild(img);
  	imgWrap.appendChild(imgLink);
  	slide.appendChild(imgWrap);

    if (item.hoverImageUrl)
    {
      const hoverImg = Object.assign( document.createElement('img'),{src: item.hoverImageUrl});
      imgLink.append(hoverImg);

      slide.classList.add('lm-recently-viewed-hover-effect');
    }
    

    const contentWrap = Object.assign( document.createElement('div'), {
      className: 'item-content-wrapper underline-links-hover'
    });

    const link = Object.assign( document.createElement('a'), {
      href: item.url,
      className: 'h5 full-unstyled-link',
      textContent: item.title
    });
    
  	contentWrap.appendChild(link);
  	slide.appendChild(contentWrap);

  	const price = (item.price_varies) ? 'From ' + formatMoney(item.price) : formatMoney(item.price);
    const priceCont = Object.assign( document.createElement('div'), {
      className: 'item-price price',
      textContent: price
    });  
    slide.append(priceCont);
    
    return slide;
  };

};



  } catch(e) { console.error(e); }
})();
})();
